<ng-template #workflowTemplate>
    @if (steps) {
        <div class="cerrix-workflow-container">
            <div class="cerrix-workflow-graph">
                <div class="workflow-step-spacer"></div>
                @for (step of steps; track step; let i = $index) {
                    <div
                        class="workflow-step"
                        [class.done]="step.stepDone"
                        [class.active]="step.stepActive"
                        [class.overdue]="step.isStepToDoverdue"
                        (click)="onStepClick(step)"
                        triggers="mouseenter:mouseleave"
                        placement="bottom"
                        [popover]="step.stepToDoDescription ? step.stepToDoDescription : ''"
                    ></div>
                    @if (i < steps.length - 1) {
                        <div class="workflow-connector" [class.done]="step.stepDone">
                            <div class="workflow-connector-icon"></div>
                            <div
                                class="workflow-connector-text"
                                triggers="mouseenter:mouseleave"
                                placement="bottom"
                                [popover]="
                                    step.stepDoneHoverText
                                        ? step.stepDoneHoverText
                                        : step.stepDoneText
                                "
                            >
                                {{ step.stepDoneText }}
                            </div>
                        </div>
                    }
                }
                <div class="workflow-step-spacer"></div>
            </div>

            <div class="cerrix-workflow-text">
                @for (step of steps; track step) {
                    <div
                        [style]="'width: calc(100% / ' + steps.length + ')'"
                        class="workflow-step-text"
                        triggers="mouseenter:mouseleave"
                        placement="bottom"
                        [popover]="step.stepDescription ? step.stepDescription : step.stepName"
                    >
                        {{ step.stepName }}
                    </div>
                }
            </div>
        </div>
    } @else {
        <div class="loader-container" style="height: 40px; transform: scale(0.4)">
            <div class="fancy-loader submodule"></div>
        </div>
    }
</ng-template>

@if (config) {
    <div [class.highlight-background]="config.highlightBackground">
        <ng-container [ngTemplateOutlet]="workflowTemplate"></ng-container>
    </div>
}
